import React from "react";
import {
  GetDocuments,
  GetDocumentsCompleted,
  GetStatusCompletedByCompany,
  GetDocumentWithPaging,
} from "./api/document";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import { useState, useEffect } from "react";
import Divider from "@mui/material/Divider";
import { Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import { FormControl } from "@mui/material";
import { TextField } from "@mui/material";
import { IconButton } from "@mui/material";
import { InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InfoIcon from "@mui/icons-material/Info";
import "./App.css";
import "./completed.css";
import DoneIcon from "@mui/icons-material/Done";
import ProtectedRoutes from "./utils/protectedRoutes";
import { useLocation } from "react-router-dom";
import { getDocumentTypes } from "./api/general";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";

function Completed() {
  let navigate = useNavigate();
  let location = useLocation();
  useEffect(() => {
    document.title = "Completed Documents";
  }, []);
  const [documents, setDocuments] = useState();
  const [nameFilter, setNameFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");
  const [dateFilter, setDateFilter] = useState(true);
  const [reviewStatusFilter, setReviewStatusFilter] = useState("All");
  const [viewingCount, setViewingCount] = useState();
  const [documentTypes, setDocumentTypes] = useState([]);
  const [documentTypesList, setDocumentTypesList] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusOptionsList, setStatusOptionsList] = useState("");
  const [docTypeID, setdocTypeID] = useState([]);
  const [fileTypeName, setFileTypeName] = useState("");
  const [fileType, setFileType] = useState();
  const [filterLength, setFilterLength] = useState("");
  const [filterButtonDisable, setFilterButtonDisable] = useState(true);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const [validRoute, setValidRoute] = useState(false);
  useEffect(() => {
    if (sessionStorage.NameFilter) {
      setNameFilter(sessionStorage.NameFilter);
    }
    if (sessionStorage.TypeFilter) {
      setTypeFilter(sessionStorage.TypeFilter);
    }
    if (sessionStorage.DateFilter) {
      setDateFilter(sessionStorage.DateFilter);
    }
    if (sessionStorage.ReviewStatusFilter) {
      setReviewStatusFilter(sessionStorage.ReviewStatusFilter);
    }
  }, []);
  useEffect(() => {
    async function fetchValidation() {
      const isValid = await ProtectedRoutes(location.pathname);
      setValidRoute(isValid);
      if (!isValid) {
        navigate("/forbidden");
      }
    }
    fetchValidation();
  }, []);

  useEffect(() => {
    (async () => {
      // Load document types and status options
      let documentType = await getDocumentTypes();
      setdocTypeID(documentType);
      documentType = [{ id: 0, templateName: "All" }, ...documentType];
      setDocumentTypes(documentType);
      setFileTypeName(documentType[0].templateName);
      setFileType(documentType[0].id);

      // Load status options from API
      const statusData = await GetStatusCompletedByCompany();
      const statusOptions = [
        { stateFileID: 0, stateFileName: "All" },
        ...statusData,
      ];
      setStatusOptions(statusOptions);
    })();
  }, []);

  // Helper function to get status ID from status name
  const getStatusIdFromName = (statusName) => {
    const status = statusOptions.find((s) => s.stateFileName === statusName);
    return status ? status.stateFileID : 0;
  };

  // Helper function to get document type ID from document type name
  const getDocumentTypeIdFromName = (documentTypeName) => {
    const docType = documentTypes.find(
      (d) => d.templateName === documentTypeName
    );
    return docType ? docType.id : 0;
  };

  // Function to fetch paginated documents from server
  const fetchPaginatedDocuments = async () => {
    setLoading(true);
    try {
      const stateFileId = getStatusIdFromName(reviewStatusFilter);
      const documentTypeTemplateId = getDocumentTypeIdFromName(typeFilter);
      // Only search if nameFilter has at least 3 characters, otherwise search for all
      const fileName = nameFilter.length >= 3 ? nameFilter : "";
      const orderType = dateFilter ? "Desc" : "Asc";

      // Note: 3-character minimum is now handled in the debounced useEffect

      // Validation logging
      console.log("🔍 API Call Validation:");
      console.log("📝 Token validation:", {
        hasToken: !!sessionStorage.token,
        tokenLength: sessionStorage.token ? sessionStorage.token.length : 0,
        tokenPreview: sessionStorage.token
          ? sessionStorage.token.substring(0, 20) + "..."
          : "No token",
      });
      console.log("📄 Filename validation:", {
        originalSearch: nameFilter,
        processedFileName: fileName,
        searchLength: nameFilter.length,
        willSearch: nameFilter.length >= 3,
      });
      console.log("📊 Request parameters:", {
        stateFileId,
        documentTypeTemplateId,
        fileName,
        currentPage,
        itemsPerPage,
        orderType,
      });

      const response = await GetDocumentWithPaging(
        stateFileId,
        documentTypeTemplateId,
        fileName,
        currentPage,
        itemsPerPage,
        orderType
      );

      if (response && response.records) {
        setDocuments(response.records);
        setTotalRecords(response.qtyRecords);
        setTotalPages(Math.ceil(response.qtyRecords / itemsPerPage));
        setFilterLength(response.qtyRecords);
        setInitialLoad(false); // Mark initial load as complete
      }
    } catch (error) {
      console.error("Error fetching paginated documents:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect to fetch documents when filters or pagination change (excluding nameFilter)
  useEffect(() => {
    if (documentTypes.length > 0 && statusOptions.length > 0) {
      fetchPaginatedDocuments();
    }
  }, [
    currentPage,
    itemsPerPage,
    typeFilter,
    reviewStatusFilter,
    dateFilter,
    documentTypes,
    statusOptions,
  ]);

  // Debounced useEffect for nameFilter search (500ms delay)
  useEffect(() => {
    if (documentTypes.length > 0 && statusOptions.length > 0) {
      const timeoutId = setTimeout(() => {
        // Only trigger search if nameFilter has 3+ characters or is empty (show all)
        if (nameFilter.length === 0 || nameFilter.length >= 3) {
          console.log("🔍 Debounced search triggered for:", nameFilter);
          fetchPaginatedDocuments();
        }
      }, 500); // 500ms debounce delay

      return () => {
        console.log("⏰ Debounce timeout cleared for:", nameFilter);
        clearTimeout(timeoutId);
      };
    }
  }, [nameFilter, documentTypes, statusOptions]);
  // useEffect for filter button disable logic
  useEffect(() => {
    if (
      nameFilter.length >= 3 ||
      !typeFilter.includes("All") ||
      reviewStatusFilter !== "All"
    ) {
      setFilterButtonDisable(false);
    } else {
      setFilterButtonDisable(true);
    }
  }, [nameFilter, typeFilter, reviewStatusFilter]);
  function handleNameFilter(text) {
    setNameFilter(text);
    sessionStorage.setItem("NameFilter", text);
    setCurrentPage(1); // Reset to first page when filter changes
  }
  function handleTypeFilter(text) {
    setTypeFilter(text);
    sessionStorage.setItem("TypeFilter", text);
    setCurrentPage(1); // Reset to first page when filter changes
  }
  function handleDateFilter(text) {
    setDateFilter(text);
    sessionStorage.setItem("DateFilter", text);
    setCurrentPage(1); // Reset to first page when filter changes
  }
  function handleReviewStatusFilter(text) {
    setReviewStatusFilter(text);
    sessionStorage.setItem("ReviewStatusFilter", text);
    setCurrentPage(1); // Reset to first page when filter changes
  }
  function handleReset() {
    setNameFilter("");
    setTypeFilter("All");
    setDateFilter(true);
    setReviewStatusFilter("All");
    sessionStorage.setItem("NameFilter", "");
    sessionStorage.setItem("TypeFilter", "");
    sessionStorage.setItem("DateFilter", "");
    sessionStorage.setItem("ReviewStatusFilter", "");
  }

  // Pagination handlers
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1); // Reset to first page when changing items per page
  };
  useEffect(() => {
    (async () => {
      const listItems = documentTypes.map((documentType) => (
        <MenuItem
          value={documentType.templateName}
          data-key={documentType.id}
          name={documentType.id}
        >
          {documentType.templateName}
        </MenuItem>
      ));
      setDocumentTypesList(listItems);
    })();
  }, [documentTypes]);

  useEffect(() => {
    (async () => {
      const statusListItems = statusOptions.map((status) => (
        <MenuItem
          value={status.stateFileName}
          data-key={status.stateFileID}
          name={status.stateFileID}
        >
          {status.stateFileName}
        </MenuItem>
      ));
      setStatusOptionsList(statusListItems);
    })();
  }, [statusOptions]);

  if (!validRoute) {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "90vh" }}
      >
        <CircularProgress color="secondary" />
      </Grid>
    );
  }

  if (loading || initialLoad) {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "90vh" }}
      >
        <CircularProgress color="secondary" />
      </Grid>
    );
  }

  async function btnClick(did, dtype) {
    console.log("filetypeid===>", dtype);
    const arrayDocuments = Array.from(docTypeID)
      .filter((item) => item.templateName == dtype)
      .map((item) => item.id);
    console.log("arrayDocuments===>", arrayDocuments[0]);

    // Fetch all documents with current filters for prev/next navigation
    const fetchAllDocuments = async () => {
      try {
        const stateFileId = getStatusIdFromName(reviewStatusFilter);
        const documentTypeTemplateId = getDocumentTypeIdFromName(typeFilter);
        const fileName = nameFilter.length >= 3 ? nameFilter : "";
        const orderType = dateFilter ? "Desc" : "Asc";

        // Fetch all documents (use a large page size to get all)
        const allDocuments = await GetDocumentWithPaging(
          stateFileId,
          documentTypeTemplateId,
          fileName,
          1, // Start from page 1
          10000, // Large page size to get all documents
          orderType
        );

        return allDocuments.records || [];
      } catch (error) {
        console.error("Error fetching all documents:", error);
        return documents; // Fallback to current page documents
      }
    };

    const allDocuments = await fetchAllDocuments();

    navigate("/document/" + did, {
      state: { documents: allDocuments, selectedDocumentID: arrayDocuments[0] },
    });
  }

  // Server-side pagination - no need for client-side filtering

  return (
    <Grid
      container
      spacing={1}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "90vh" }}
    >
      <Grid xs={12} container direction="row" spacing={2}>
        <Grid item xs={12} md={3}>
          <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            sx={{ height: 60, ml: 2 }}
          >
            <h4>Completed Documents</h4>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ ml: 2, height: 60 }}
          >
            Show
            <Select
              labelId="filetype-simple-select-label"
              id="filetype-simple-select"
              value={typeFilter}
              //label="File Type"
              onChange={(e) => handleTypeFilter(e.target.value)}
              color="secondary"
              sx={{ ml: 2, mr: 2 }}
            >
              {documentTypesList}
            </Select>
            files with status
            <Select
              labelId="review-status-simple-select-label"
              id="review-status-simple-select"
              value={reviewStatusFilter}
              onChange={(e) => handleReviewStatusFilter(e.target.value)}
              color="secondary"
              sx={{ ml: 2, mr: 2 }}
            >
              {statusOptionsList}
            </Select>
            sorted by
            <Select
              labelId="filetype-simple-select-label"
              id="datetype-simple-select"
              value={dateFilter}
              //label="File Type"
              onChange={(e) => handleDateFilter(e.target.value)}
              color="secondary"
              sx={{ ml: 2, mr: 2 }}
            >
              <MenuItem value={true}>Newest </MenuItem>
              <MenuItem value={false}>Oldest</MenuItem>
            </Select>
          </Box>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ height: 60 }}
          >
            <FormControl>
              <TextField
                id="search-box"
                value={nameFilter}
                type="text"
                color="secondary"
                placeholder="Search documents (min 3 characters, 500ms delay)"
                width="500px"
                onChange={(event) => handleNameFilter(event.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="clear search"
                        onClick={(event) => handleNameFilter("")}
                        edge="end"
                      >
                        {nameFilter.length > 0 ? (
                          <ClearIcon />
                        ) : (
                          <SearchIcon
                            sx={{
                              color:
                                nameFilter.length > 0 && nameFilter.length < 3
                                  ? "warning.main"
                                  : "text.secondary",
                            }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            <Box display="flex" justifyContent="flex-end">
                       {" "}
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={handleReset}
                disabled={filterButtonDisable}
              >
                Reset{" "}
              </Button>
                  {" "}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <List
        style={{ height: "65vh", overflow: "auto" }}
        sx={{
          width: "100%",
          mt: 1,

          // hover states
          "& .MuiListItem-root:hover": {
            bgcolor: "#dbdbe3",
          },
        }}
      >
        {!initialLoad && (!documents || documents.length < 1) ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
              flexDirection: "column",
            }}
          >
            <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
              No documents found.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Try adjusting your filters or search criteria.
            </Typography>
          </Box>
        ) : (
          documents &&
          documents.map((document, index) => {
            return (
              <>
                <ListItem
                  key={index}
                  id={document.fileName}
                  onClick={() => btnClick(document.id, document.documentType)}
                >
                  <ListItemAvatar>
                    {document.stateId == 4 ? (
                      <p class="xglyph-font">&#57368;</p>
                    ) : (
                      <p class="xglyph-font">&#57816;</p>
                    )}
                  </ListItemAvatar>

                  <ListItemText
                    primary={document.fileName}
                    secondary={document.dateUpdated.substring(0, 10)}
                  />

                  {document.stateId == 4 ? (
                    <Chip
                      label="Error"
                      size="small"
                      variant="outlined"
                      color="error"
                      sx={{ mr: 1 }}
                    />
                  ) : (
                    ""
                  )}
                  <Box sx={{ display: { xs: "none", md: "block" } }}>
                    <Tooltip title="Document Type" arrow>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mr: 2 }}
                      >
                        {document.documentType}
                      </Typography>
                    </Tooltip>
                  </Box>

                  <Tooltip title="Status" arrow>
                    <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                      <i
                        class="xgl-issue xglsize-16"
                        style={{ marginRight: "4px", color: "#757575" }}
                      ></i>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 500 }}
                      >
                        {document.stateFile}
                      </Typography>
                    </Box>
                  </Tooltip>
                </ListItem>
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid
                    item
                    sx={{ display: { xs: "block", md: "none" } }}
                    xs={3}
                  >
                    <Tooltip title="Document Type" arrow>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        {document.documentType}
                      </Typography>
                    </Tooltip>
                  </Grid>
                </Grid>

                <Divider />
              </>
            );
          })
        )}
      </List>
      <Box
        id="footer"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          mt: 2,
          mb: 2,
        }}
      >
        {/* Items per page selector */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Show
          </Typography>
          <Select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            size="small"
            variant="outlined"
            sx={{ minWidth: 80 }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
          <Typography variant="body2" color="text.secondary">
            per page
          </Typography>
        </Box>

        {/* Pagination component */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="secondary"
          size="large"
          showFirstButton
          showLastButton
          disabled={totalPages <= 1}
        />

        {/* Results summary */}
        <Typography variant="body2" color="text.secondary">
          Showing {Math.min((currentPage - 1) * itemsPerPage + 1, totalRecords)}{" "}
          to {Math.min(currentPage * itemsPerPage, totalRecords)} of{" "}
          {totalRecords} documents
        </Typography>
      </Box>
    </Grid>
  );
}

export default Completed;
